var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!this.$store.state.isLogin)?_c('RegisWorld'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }